<template>
  <div id="data-list-list-view" class="data-list-container m-5">
    <vs-alert :color="response.AlertColor" :title="response.Title"
      :active.sync="response.StatusCode != 200 && response.StatusCode != null">
      <span>{{ response.Body }} </span>
    </vs-alert>

    <div v-if="response.StatusCode == 200">

      <div class="vx-col lg:w-3/4" style="margin:auto">
        <vx-card>
          <h4 style="text-align: center"> {{ response.Data.Course.Name }} {{ $t('CourseExam') }} </h4>
          <h3> {{ timeLeft }}</h3>
        </vx-card>

        <vx-card class="p-5 mt-5">
          <div class="vx-row">
            <div>
              <!-- <div v-if="Counter-item.TimeOfQuestionInMinute==$route.params.TimeOfExam-(item.TimeOfQuestionInMinute+sumTimeQuestion)">  -->
              <!-- <vs-button v-if="!response.Data.CourseClassExamQuestions[indexQuestion].IsAppearAgain&&!(sumTimeQuestion<=response.Data.CourseClassExamQuestions[indexQuestion].TimeMustAppear)" @click="response.Data.CourseClassExamQuestions[indexQuestion].IsAppearAgain=true" color="danger" >
                    {{indexQuestion+1}}/{{response.Data.CourseClassExamQuestions.length}}-{{response.Data.CourseClassExamQuestions[indexQuestion].QuestionText}} <h3> answer again </h3></vs-button> -->
              <!-- <button v-if="!item.IsAppearAgain&&!(sumTimeQuestion<=item.TimeMustAppear)">answer again </button> -->
              <!-- v-if="sumTimeQuestion<=response.Data.CourseClassExamQuestions[indexQuestion].TimeMustAppear||response.Data.CourseClassExamQuestions[indexQuestion].IsAppearAgain" -->

              <div>
                <!-- <div v-if="sumTimeQuestion<=item.TimeMustAppear&&item.TimeMustAppear<5" style="background-color:#bd6f80">  -->
                <!-- <h3>{{questionTimeLeft}}</h3> -->
                <!-- <label v-if="sumTimeQuestion<=response.Data.CourseClassExamQuestions[indexQuestion].TimeMustAppear&&response.Data.CourseClassExamQuestions[indexQuestion].TimeMustAppear-sumTimeQuestion<response.Data.CourseClassExamQuestions[indexQuestion].TimeOfQuestionInMinute" >{{(response.Data.CourseClassExamQuestions[indexQuestion].TimeMustAppear-sumTimeQuestion)}} minutes</label>  *60 3lshan a7wlha mn minutes l seconds -->
                {{ response.Data.CourseClassExamQuestions[indexQuestion].QuestionType.Name }}
                <div class="vx-row">
                  <label
                    class="mt-3 pl-3">{{ indexQuestion + 1 }}/{{ response.Data.CourseClassExamQuestions.length }}-{{ response.Data.CourseClassExamQuestions[indexQuestion].QuestionText }}</label>
                  <!-- <vs-checkbox class="mt-2" v-if="response.Data.CourseClassExamQuestions[indexQuestion].QuestionTypeID==2" v-model="response.Data.CourseClassExamQuestions[indexQuestion].Answer"></vs-checkbox>  -->
                </div>
                <div class="mt-5 mb-5">
                  <div class="mt-5 mb-5"
                    v-for="attch in response.Data.CourseClassExamQuestions[indexQuestion].CourseClassExamQuestionAttachments"
                    :key="attch.ID">
                    <img v-show="attch.AttachmentTypeID == 7" :src="DownUrl + attch.UrlAttachment">
                    <video v-show="attch.AttachmentTypeID == 8" controls>
                      <source :src="DownUrl + attch.UrlAttachmen" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                    <p v-show="attch.AttachmentTypeID >= 1 && attch.AttachmentTypeID <= 4">PDF file <a
                        :href="DownUrl + attch.UrlAttachment" target="_blank">open</a></p>
                  </div>
                </div>
                <div class="mt-5 ml-5 row"
                  v-show="response.Data.CourseClassExamQuestions[indexQuestion].QuestionTypeID == 2">
                  <div class="vx-row ">
                    <div class="radu">
                      <input class="radu mb-5" type="radio" :id="response.Data.CourseClassExamQuestions[indexQuestion].ID"
                        v-model="response.Data.CourseClassExamQuestions[indexQuestion].Answer" value="True">
                    </div>
                    <div style="margin-top:5px">
                      <label for="True">True</label>
                    </div>
                  </div>

                  <div class="vx-row ">
                    <div class="radu">
                      <input class="radu mb-5" type="radio" :id="response.Data.CourseClassExamQuestions[indexQuestion].ID"
                        v-model="response.Data.CourseClassExamQuestions[indexQuestion].Answer" value="False">
                    </div>
                    <div style="margin-top:5px">
                      <label for="False">False</label>
                    </div>
                  </div>
                </div>
                <div class="mt-5 ml-5" v-show="response.Data.CourseClassExamQuestions[indexQuestion].QuestionTypeID == 3">
                  <div v-for="Ans in response.Data.CourseClassExamQuestions[indexQuestion].CourseClassExamQuestionAnswers"
                    :key="Ans.ID">
                    <vs-radio v-model="response.Data.CourseClassExamQuestions[indexQuestion].Answer"
                      :vs-name="response.Data.CourseClassExamQuestions[indexQuestion].ID"
                      :vs-value="Ans.ID">{{ Ans.AnswerText }}</vs-radio>
                  </div>
                </div>
                <div class="pl-5 mt-5" v-show="response.Data.CourseClassExamQuestions[indexQuestion].ExtraAnswer">
                  <vs-textarea class="w-full"
                    v-model="response.Data.CourseClassExamQuestions[indexQuestion].ExtraAnswerText"></vs-textarea>
                </div>
                <div class="pl-5" v-show="response.Data.CourseClassExamQuestions[indexQuestion].QuestionTypeID == 1">
                  <vs-textarea class="w-full"
                    v-model="response.Data.CourseClassExamQuestions[indexQuestion].Answer"></vs-textarea>
                </div>
                <div class="pl-5 mt-5"
                  v-show="response.Data.CourseClassExamQuestions[indexQuestion].HaveAttachmentAnswer">
                  <vs-upload automatic :limit="1" :action="baseURL + 'API/CourseQuestionBank/UploadFile'"
                    :headers="UploadRequestHeader" @on-success="successUpload" />
                </div>

              </div>
            </div>
          </div>
        </vx-card>

        <div class="mt-5 flex flex-wrap-reverse items-center flex-grow justify-between">
          <div style="margin:auto"> <vs-button @click="previous" v-show="indexQuestion > 0">{{ $t('PreviousQuestion') }}
            </vs-button></div>
          <div style="margin:auto"> <vs-button @click="next"
              v-show="indexQuestion + 1 < response.Data.CourseClassExamQuestions.length">{{ $t('NextQuestion') }} </vs-button>
          </div>
        </div>

      </div>
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="mr-6" @click="confirmSubmit">{{ $t('SubmitAnswers') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moduleCourseClassExam from "@/store/courseClassExam/moduleCourseClassExam.js";
import moduleTraineeExamAnswer from "@/store/traineeExamAnswer/moduleTraineeExamAnswer.js";
import { domain, mainSetting } from '@/gloabelConstant.js';

export default {
  data() {
    return {
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      baseURL: domain,
      indexQuestion: 0,
      TimeOfExam: 0,
      sumTimeQuestion: 1,
      Counter: this.$route.params.TimeOfExam,
      DownUrl: domain,
      response: {},
      timeLeft: '00:00',
      questionTimeLeft: '00:00',
      initialTime: {},
      examTime: {},
      isSubmited: false

    }
  },
  computed: {

  },
  methods: {
    successUpload(event) {
      this.response.Data.CourseClassExamQuestions[this.indexQuestion].AttachmentAnswer = event.target.responseText;
      this.$vs.notify({
        color: 'success',

        title: 'Upload Success',
        text: this.$t("SuccessuploadyourAttachment")
      })

    },
    countdown(end) {
      debugger
      this.examTime = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft === 0) {
          this.endTime = 0;
        }

        if (secondsLeft < 0) {
          this.submitExamAnswer();
          clearInterval(this.examTime);
          return;
        }
        this.displayTimeLeft(secondsLeft)
      }, 1000);
    },

    displayTimeLeft(secondsLeft) {
      const hours = Math.floor((secondsLeft % 216000) / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      this.timeLeft = `${this.zeroPadded(hours)}:${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`;
    },

    questionCountdown(end) {
      debugger
      this.initialTime = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft === 0) {
          this.questionTimeLeft = "00:00"
          this.endTime = 0;
        }

        if (secondsLeft < 0) {
          this.questionTimeLeft = "00:00"
          clearInterval(this.initialTime);
          return;
        }
        this.questiondisplayTimeLeft(secondsLeft)
      }, 1000);
    },

    questiondisplayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      this.response.Data.CourseClassExamQuestions[this.indexQuestion].TimeOfQuestionInMinute = secondsLeft / 60;
      this.questionTimeLeft = `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`;
    },

    zeroPadded(num) {
      // 4 --> 04
      return num < 10 ? `0${num}` : num;
    },

    hourConvert(hour) {
      // 15 --> 3
      return (hour % 12) || 12;
    },
    previous() {
      debugger
      if (this.indexQuestion == 0) {

      }
      else {
        this.indexQuestion--;
        clearInterval(this.initialTime);
        const now = Date.now();
        const end = now + this.response.Data.CourseClassExamQuestions[this.indexQuestion].TimeOfQuestionInMinute * 60 * 1000
        this.questionCountdown(end);
      }
    },
    next() {
      debugger
      if (this.indexQuestion == this.response.Data.CourseClassExamQuestions.length - 1) {

      }
      else {
        this.indexQuestion++;
        clearInterval(this.initialTime);
        const now = Date.now();
        const end = now + this.response.Data.CourseClassExamQuestions[this.indexQuestion].TimeOfQuestionInMinute * 60 * 1000
        this.questionCountdown(end);
      }
    },
    sumOfLastQuestion() {
      this.sumTimeQuestion++;
    },

    confirmSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantsubmitanswer") + "?",
        accept: this.submitExamAnswer
      });
    },

    submitExamAnswer() {
      if (!this.isSubmited) {
        this.isSubmited = true;
        var CourseClassExamQuestions = this.response.Data.CourseClassExamQuestions.map(function (val) { var obj = {}; obj.Answer = val.Answer; return obj; });

        debugger
        var ExameCode = this.$route.params.Code;
        this.$vs.loading();
        this.$store.dispatch('traineeExamAnswerList/submitTraineeExamAnswer',
          this.response.Data.CourseClassExamQuestions).then(() => {
            this.$vs.loading.close();
            debugger;
            this.$store.dispatch("traineeExamAnswerList/getResultOFGeneralExam", ExameCode).then((response) => {
              debugger
              this.response.StatusCode = 201;
              this.response.Body = "Answers submited successfully , And Your Initial Result is " + response.data;
              this.response.AlertColor = "warning";
              this.response.Title = "Successfully";

            })

          }).catch(() => {
            this.$vs.loading.close();
            debugger
            this.response.StatusCode = 404;
            this.response.Body = "Unexpected error";
            this.response.AlertColor = "danger";

            this.response.Title = "Error";
          })
      }
    }
  },
  created() {
    if (!moduleCourseClassExam.isRegistered) {
      this.$store.registerModule("courseClassExamList", moduleCourseClassExam);
      moduleCourseClassExam.isRegistered = true;
    }

    if (!moduleTraineeExamAnswer.isRegistered) {
      this.$store.registerModule("traineeExamAnswerList", moduleTraineeExamAnswer);
      moduleTraineeExamAnswer.isRegistered = true;
    }

    const Code = this.$route.params.Code
    debugger
    if (Code != undefined) {
      this.$vs.loading();
      this.$store.dispatch("courseClassExamList/GetCourseClassExamByCode", Code)
        .then(res => {
          this.$vs.loading.close();
          if (res.data.StatusCode == 404) {
            this.response.StatusCode = 404;
            this.response.Body = res.data.Body;
            this.response.AlertColor = "danger";
            this.response.Title = "Error";
            return;
          }
          debugger
          this.TimeOfExam = res.data.Data.TimeOfExamInMinutes * 60 * 1000;
          this.response = res.data;
          const now = Date.now();
          const end = now + this.TimeOfExam;
          this.countdown(end);
          const now2 = Date.now();
          const end2 = now2 + this.response.Data.CourseClassExamQuestions[this.indexQuestion].TimeOfQuestionInMinute * 60 * 1000
          this.questionCountdown(end2);
        })
        .catch(() => {
          this.$vs.loading.close();
          this.response.StatusCode = 404;
          this.response.Body = "Unexpected error";
          this.response.AlertColor = "danger";
          this.response.Title = "Error";

        })
    }
  },

  mounted() {
    this.isMounted = true;

    //for question counter
    // if(this.$route.params.TimeOfExam>0){
    //           window.setInterval(() => {
    //        debugger
    //        this.sumOfLastQuestion();
    //              },60*1000);
    //      }

    //     //for counter
    //      if(this.$route.params.TimeOfExam>0){
    //           window.setInterval(() => {
    //        debugger
    //        this.Counter= this.Counter-1;
    //              },60*1000);
    //      }

    //for time of exam
    // if(this.$route.params.TimeOfExam>0){
    //       window.setInterval(() => {
    //    debugger
    //  this.submitExamAnswer();
    //          },this.$route.params.TimeOfExam*60*1000);
    //  }

  },

}
</script>

<style scoped>.radu {
  color: #AAAAAA;
  width: 30%;
  height: 30px;
}</style>
